/**
 * @generated SignedSource<<21d5cd427c0444bea6423dc4b86168d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateOutlookCalendarInput = {
  id?: string | null;
  viewPrivateEvents?: boolean | null;
  enabledCalendarIds?: ReadonlyArray<string | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type UpdateOutlookCalendarMutation$variables = {
  input: UpdateOutlookCalendarInput;
};
export type UpdateOutlookCalendarMutation$data = {
  readonly updateOutlookCalendar: {
    readonly outlookCalendar: {
      readonly calendarViewPrivateEvents: boolean | null;
      readonly enabledCalendars: ReadonlyArray<string | null> | null;
    } | null;
  } | null;
};
export type UpdateOutlookCalendarMutation$rawResponse = {
  readonly updateOutlookCalendar: {
    readonly outlookCalendar: {
      readonly calendarViewPrivateEvents: boolean | null;
      readonly enabledCalendars: ReadonlyArray<string | null> | null;
      readonly id: string;
    } | null;
  } | null;
};
export type UpdateOutlookCalendarMutation = {
  variables: UpdateOutlookCalendarMutation$variables;
  response: UpdateOutlookCalendarMutation$data;
  rawResponse: UpdateOutlookCalendarMutation$rawResponse;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "calendarViewPrivateEvents",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabledCalendars",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateOutlookCalendarMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateOutlookCalendarPayload",
        "kind": "LinkedField",
        "name": "updateOutlookCalendar",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CalendarIntegration",
            "kind": "LinkedField",
            "name": "outlookCalendar",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateOutlookCalendarMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateOutlookCalendarPayload",
        "kind": "LinkedField",
        "name": "updateOutlookCalendar",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CalendarIntegration",
            "kind": "LinkedField",
            "name": "outlookCalendar",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6d3d41be9b824fe9748d0e6334258a23",
    "id": null,
    "metadata": {},
    "name": "UpdateOutlookCalendarMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateOutlookCalendarMutation(\n  $input: UpdateOutlookCalendarInput!\n) {\n  updateOutlookCalendar(input: $input) {\n    outlookCalendar {\n      calendarViewPrivateEvents\n      enabledCalendars\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "81e8f838f8ea4b2d43d19a4f172fb058";

export default node;
